var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('h1',{staticClass:"blueDark--text mb-5"},[_vm._v("Net Contract Airline: "+_vm._s(_vm.$route.params.id))]),_c('div',[_c('object',{staticStyle:{"border":"0","width":"100%","min-height":"1000px"},attrs:{"data":`https://adamtravel.net/dropnet_comm/showContractByairline.php?airline=${_vm.$route.params.id}`}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }